
<script setup lang="ts">
const excerpt = undefined
  defineExpose({ frontmatter: {}, excerpt: undefined })
</script>
<script lang="ts">
/** frontmatter meta-data for MD page **/
export interface Frontmatter {
  title?: string
  description?: string
  subject?: string
  category?: string
  name?: string
  excerpt?: string
  image?: string
  layout?: string
  requiredAuth?: boolean
  meta?: Record<string, any>[]
  [key: string]: unknown
}
export const frontmatter: Frontmatter = {}
export const excerpt: string | undefined = ""

</script>
<template>
<div class="markdown-body"><p><strong>Kurtosis</strong> measures the weightage of the distribution tails with reference to
the all-around distribution curve, where excess kurtosis represents the fat
tail in return distribution. Positive (negative) kurtosis implies that there are
more (fewer) extremely larger gains (losses) than a normal distribution.
Kurtosis focuses on the extreme values in either tail.</p>
</div>
</template>
